module.exports = __webpack_public_path__ + "img/CZE.29c63514.svg";